import { z } from 'zod';
import { t } from 'i18next';
import { OnboardingFormFields } from '@Types/index.ts';
import { Line1Schema } from '@Components/inputs/Line1';
import { addressStateNonUs, AddressStateSchema } from '@Components/inputs/AddressStateDropDown';
import { zipSchema, zipSchemaWNonUs } from '@Components/inputs/ZipAddress';
import { citySchema } from '@Components/inputs/CityInput';

export const HomeAddressFormScheme = z.object({
  ...Line1Schema.shape,
  [OnboardingFormFields.APARTMENT]: z.string().optional(),
  ...citySchema.shape,
  ...zipSchema.shape,
  ...AddressStateSchema.shape,
});
export const createNonUsHomeAddressSchema = () =>
  z.object({
    ...Line1Schema.shape,
    [OnboardingFormFields.APARTMENT]: z.string().optional(),
    [OnboardingFormFields.COUNTRY]: z.any().refine((value) => Boolean(value), {
      error: () => t('enErrors:required'),
    }),
    ...citySchema.shape,
    ...addressStateNonUs.shape,
    ...zipSchemaWNonUs.shape,
  });
